<template>
  <v-card outlined>

    <v-row class="pl-4" v-if="mode===1">

      <v-col v-if="isImage && !!downloadUrl" class="shrink clickable" v-on:click="fireClickEvent">
        <image-view :height="70" :width="70" :src="downloadUrl"></image-view>
      </v-col>

      <v-col v-if="!isImage" class="shrink clickable">
        <a v-if="downloadType === 's3'" :href="downloadUrl" target="_blank" rel="noopener">
          <span v-if="iconType === 'pdf'"><i class="far fa-4x fa-file-pdf"></i></span>
          <span v-if="iconType === 'file'"><i class="far fa-4x fa-file"></i></span>
        </a>
        <a v-if="downloadType === 'api'" v-on:click.prevent="onDownloadFile(buildApiServerUrl(downloadUrl),fileName)" rel="noopener">
          <span v-if="iconType === 'pdf'"><i class="far fa-4x fa-file-pdf"></i></span>
          <span v-if="iconType === 'file'"><i class="far fa-4x fa-file"></i></span>
        </a>
      </v-col>

      <v-col v-if="showFileName">
        <v-container>
          <v-row>
            <span class="caption">{{fileName}}</span>
          </v-row>
          <v-row justify="end">
            <v-btn v-if="canDelete" text color="orange" v-on:click="fireDeleteEvent">DELETE</v-btn>
          </v-row>
        </v-container>
      </v-col>

      <v-col v-else>
        <v-container>
          <v-row justify="end">
            <v-btn v-if="canDelete" text color="orange" v-on:click="fireDeleteEvent">DELETE</v-btn>
          </v-row>
        </v-container>
      </v-col>

    </v-row>

  </v-card>
</template>
<script>
import Common from "@/components/Common";
import FileAssetAPI from "@/apis/FileAssetAPI";
import Util from "@/Util"

export default {
  mixin:[Common],
  props:{
    fileId: {
      type: Number,
      required: true
    },
    showFileName: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      mode:1,
      loading:false,
      contentType:"",
      fileName:"",
      downloadUrl:"",
      downloadType:"",
    }
  },
  watch:{
    'fileId':function(val){
      this.startImageLoading();
    },
  },
  computed:{
    iconType(){
      if (!!this.downloadUrl){
        let contentType = this.contentType;
        if (contentType === "image" || contentType === "image/png" || contentType === "image/jpeg"){
          return "image";
        }

        if (contentType === "application/pdf"){
          return "pdf";
        }

        return "file";
      }
      return "";
    },
    isImage(){
      if (!!this.downloadUrl){
        let contentType = this.contentType;
        if (contentType === "image" || contentType === "image/png" || contentType === "image/jpeg"){
          return true;
        }
      }
      return false;
    },
  },
  mounted() {
    this.startImageLoading();
  },
  methods: {
    startImageLoading(){
      let self = this;

      this.loading = true;

      let urlProc = this.getFileInfo();
      if (urlProc == null){
        self.loading = false;
        return;
      }

      urlProc.then(fileInfo => {
        self.loading = false;

        console.log("FileCard urlProcResult",fileInfo);        

        if (!fileInfo){
          self.contentType = "";
          self.fileName = "";
          self.downloadUrl = "";
          self.downloadType = "";
        } else {
          self.contentType = fileInfo.contentType;
          self.fileName = fileInfo.fileName;
          self.downloadUrl = fileInfo.url;
          self.downloadType = fileInfo.downloadType;
        }
      });

    },


    getFileInfo(){
      let self = this;
      if (!this.fileId){
        return null
      }
      return FileAssetAPI.fileInfo(this.fileId)
          .then(a => a);
    },
    fireDeleteEvent(){
      this.$emit('delete',this.fileId);
    },

    fireClickEvent(){

      let data = {
        fileId:this.fileId,
        contentType:this.contentType,
        fileName:this.fileName,
        downloadUrl:this.downloadUrl,
        isImage:(this.iconType === 'image'),
      };

      this.$emit('click',data);
    },


    onDownloadFile(url,fileName){
      let authToken = this.$store.state.account.idToken;
      fetch(url, { method: 'GET', headers: new Headers([["Authorization", authToken]])})
          .then(response => response.blob())
          .then(blob => {
            let anchor = document.createElement("a");
            anchor.href = window.URL.createObjectURL(blob);
            anchor.download = fileName;
            anchor.click();
          })
    },

  },
}
</script>
